<template>
  <b-form @submit.prevent="submitForm">
    <b-row class="mb-1 py-2 font-weight-bolder bg-light">
      <b-col md="2">
        Analyte
      </b-col>
      <b-col>Irrigated</b-col>
      <b-col md="2">
        Very Low
      </b-col>
      <b-col md="2">
        Low
      </b-col>
      <b-col md="2">
        High
      </b-col>
    </b-row>

    <b-row class="mb-2 py-2 align-items-center">
      <b-col md="2">
        {{ analyte.name }}
      </b-col>

      <b-col>
        <b-form-checkbox
          v-model="form_data.irrigated"
          :value="1"
          :unchecked-value="0"
        >
          Irrigated?
        </b-form-checkbox>
      </b-col>

      <b-col md="2">
        <b-form-input
          v-model="form_data.very_low"
          type="text"
          placeholder="Very Low"
        />
      </b-col>

      <b-col md="2">
        <b-form-input
          v-model="form_data.low"
          type="text"
          placeholder="Low"
        />
      </b-col>

      <b-col md="2">
        <b-form-input
          v-model="form_data.high"
          type="text"
          placeholder="High"
        />
      </b-col>
    </b-row>

    <div class="d-flex justify-content-end">
      <b-button variant="danger" class="mx-2" @click="$emit('close')">
        Cancel
      </b-button>
      <b-button variant="success" @click="submitForm">
        <i class="fa fa-save" /> Save
      </b-button>
    </div>
  </b-form>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import AnalyteRangeRepository from '@/repositories/lab/AnalyteRangeRepository'
import { notificationOptions } from '@/shared/toast-notification-options'
import { analyteRangeNotifications } from '@/shared/notifications'

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'AnalyteRangeFormSoilAdd',
  props: {
    analyte: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      form_data: {
        analyte_id: this.analyte.id,
        irrigated: false,
        very_low: null,
        low: null,
        high: null
      },

      submitting: false
    }
  },
  methods: {
    async submitForm () {
      this.submitting = true

      try {
        await AnalyteRangeRepository.create(this.form_data)

        this.addSuccess()
        this.$emit('saved')
      } catch (error) {
        console.error(error)
      }

      this.submitting = false
    }
  },
  notifications: analyteRangeNotifications
}
</script>
